import { api } from '@/config/api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface DefaultBotFlow {
  _id: string;
  defaultFlowUid: string;
  title: string;
  description?: string;
  industries: string[];
  tags: string[];
  thumbnailUrl?: string;
  name: string;
  triggerType: string;
  triggerConfig: Record<string, unknown>;
  states: Array<Record<string, unknown>>;
  startStateId: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GalleryListResult {
  items: DefaultBotFlow[];
  total: number;
  page: number;
  limit: number;
}

export interface GalleryListParams {
  industry?: string;
  q?: string;
  page?: number;
  limit?: number;
}

// ─── Service ──────────────────────────────────────────────────────────────────

export const botFlowGalleryService = {
  list: async (params: GalleryListParams = {}): Promise<GalleryListResult> => {
    const search = new URLSearchParams();
    if (params.industry) search.set('industry', params.industry);
    if (params.q) search.set('q', params.q);
    if (params.page) search.set('page', String(params.page));
    if (params.limit) search.set('limit', String(params.limit));
    return (await api.get(`/slighter_crm/bot-flow-gallery?${search.toString()}`)).data;
  },

  get: async (uid: string): Promise<DefaultBotFlow> =>
    (await api.get(`/slighter_crm/bot-flow-gallery/${uid}`)).data,

  clone: async (uid: string, accountUid?: string): Promise<{ flowUid: string; name: string }> =>
    (await api.post(`/slighter_crm/bot-flow-gallery/${uid}/clone`, { accountUid })).data,
};
